// extracted by mini-css-extract-plugin
export default {"InfoSection":"InfoSection_InfoSection__hBcyZ","FieldContainer":"InfoSection_FieldContainer__tVdvK"};